<template>
  <div class="language-selector-container">
    <select class="language-selector form-control small" v-model="lang" @change="translate">
      <option disabled="">{{$t('header.languages')}}</option>
      <option v-for="lg in langs" :value="lg">{{$t('language.' + lg)}}</option>
    </select>
    <span class="caret"></span>
  </div>
</template>

<script>
import {
  domain,
  supportedLocales
} from '../../config'

export default {
  name: "LanguageLogin",
  data: function() {
    return {
      endpoint: domain + '/login/auth',
      langs: _transformToLanguages(supportedLocales)
    }
  },
  props: ['lang'],
  methods: {
    translate() {
      window.location.href = this.endpoint + '?lang=' + this.lang
    }
  }
}

function _transformToLanguages(languages) {
  return languages.substring(1).slice(0, -1).replace(/ /g,'').split(',');
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// LanguageLogin.vue?19421250